import { ActionButton } from 'mfa'
import {
  CURRENT_PASSWORD,
  PASSWORD_CHANGE_TITLE,
} from '../../constants/ui.labels'
import PasswordChangeFieldGroup from '../PasswordChangeFieldGroup'
import PasswordInputFieldGroup from '../PasswordInputFieldGroup'
import Box from '@talkdesk/cobalt-react-box'

const ChangePasswordForm = ({
  disabledForm = false,
  onSubmit,
  oldPassword,
  password,
  passwordConfirmation,
  isValid,
  onFormChange,
}) => {
  const handleOldPasswordChange = (event) => {
    onFormChange({ oldPassword: event.target.value })
  }

  const isSubmitDisabled = disabledForm || !isValid

  const handleFormSubmit = (event) => {
    event.preventDefault()
    if (isSubmitDisabled) {
      return
    }
    onSubmit(event)
  }

  return (
    <form onSubmit={handleFormSubmit}>
      <PasswordInputFieldGroup
        label={CURRENT_PASSWORD}
        disabledForm={disabledForm}
        placeholder={CURRENT_PASSWORD}
        password={oldPassword}
        onPasswordChange={handleOldPasswordChange}
        autoFocus
      />
      <PasswordChangeFieldGroup
        formData={{ password, passwordConfirmation }}
        onFormChange={onFormChange}
        disabledForm={disabledForm}
      />
      <Box paddingTop='2'>
        <ActionButton
          htmlType='submit'
          isProcessing={disabledForm}
          isDisabled={isSubmitDisabled}
          shape='full-width'
        >
          {PASSWORD_CHANGE_TITLE}
        </ActionButton>
      </Box>
    </form>
  )
}

export default ChangePasswordForm
